(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CompetitorDialogController', CompetitorDialogController);

    CompetitorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Competitor'];

    function CompetitorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Competitor) {
        var vm = this;
        vm.competitor = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:competitorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.competitor.id !== null) {
                Competitor.update(vm.competitor, onSaveSuccess, onSaveError);
            } else {
                Competitor.save(vm.competitor, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
